import moment from 'moment-timezone'
import 'moment/locale/de'
import 'moment/locale/es'
import 'moment/locale/es-mx'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/pt'

class DateFormatter {
    static __ = window.__ || ((str) => str);

    static formatDate(dateStr, timezone, locale = 'en') {
        if (!dateStr || !timezone) return '-';
        moment.locale(locale);
        return moment(dateStr).tz(timezone).format('M/D/YYYY, h:mm A z');
    }

    static formatDateOnly(dateStr, timezone, locale = 'en') {
        if (!dateStr || !timezone) return '-';
        moment.locale(locale);
        return moment(dateStr).tz(timezone).format('MMMM DD');
    }

    static getTimeUntil(remindAt, format = 'short') {
        const now = moment();
        const target = moment(remindAt instanceof Date ? remindAt.toISOString() : remindAt);

        if (!target.isValid()) return this.__('Invalid date');
        if (target.isSameOrBefore(now)) return this.__('Already sent');

        const dur = moment.duration(target.diff(now));
        const days = Math.floor(dur.asDays());
        const h = dur.hours();
        const m = dur.minutes();

        return format === 'long'
            ? `${days} ${this.__(days === 1 ? 'day' : 'days')}, ${h} ${this.__(h === 1 ? 'hour' : 'hours')}, ${m} ${this.__(m === 1 ? 'minute' : 'minutes')} ${this.__('left')}`
            : `${days}d ${h}h ${m}m ${this.__('left')}`;
    }
}

export default DateFormatter;
